<template>
  <div class="tpehealth-app-template-testing-method-page col-block width-full">
    <div class="tpehealth-app-sample-info-container">
      <div class="tpehealth-app-sample-info-block row-block" v-for="(option, oindex) in sampleInfoOptions" :key="oindex">
        <div class="tpehealth-app-sample-info-title">{{ option.title + '：' }}</div>
        <div class="tpehealth-app-sample-info-content" :class="{ 'bold': option.contentBold }">{{ option.value }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
    </div>
    <div class="tpehealth-app-content-sub-container col-block width-full">
      <div class="tpehealth-app-content-sub-title-container row-block">
        <div class="tpehealth-app-content-sub-title">{{ '檢測說明'/* ___ */ }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div class="tpehealth-app-content-sub-content-container col-block width-full">
        <ul>
          <li v-html="'1000ng 待測檢體的基因體 DNA 經超音波震盪處理，片斷化成為平均為 250~450bp 的 DNA 片段。採 用符合 Illumina 平台的 Whole Genome Sequencing PCR-Free 進行文庫製備。DNA 片段經過放大 後，放大後的產物會經由 NovaSeq 定序儀進行 2 x 150 bp Paired-End 的定序。'/* ___ */"></li>
          <li v-html="'分析方法依生物資訊公司所建立之分析流程進行，下機之序列經分群去標籤化後，根據 GRCh38 使用 Parabrick (4.5.0-1) 進行序列比對及 Parabrick (4.5.0-1) 進行變異位點找尋。確認的變異位點經由 Variant Effect Predictor (v101) 及 Jannovar(0.35) 進行註解。根據 ACMG / AMP 2015 指南對遺傳變異 進行臨床解釋。'/* ___ */"></li>
          <li>
            <span v-html="'本檢測方法存在以下限制:'/* ___ */"></span>
            <ul>
              <li v-html="'重複序列:基因體中充滿了高度重複的序列。當碎片太小時，難以判斷這些碎片該歸位在哪裡(如X 染色體脆折症)。'/* ___ */"></li>
              <li v-html="'結構變異:對於大型的 DNA 倒置、轉位或大片段缺失，短讀⻑技術難以精確偵測。'/* ___ */"></li>
              <li v-html="'動態突變:某些疾病(如小腦萎縮症、亨丁頓舞蹈症)是由特定序列的大量重複引起的，全基因體定序(WGS)在精確計算這些重複次數上仍有挑戰。'/* ___ */"></li>
              <li v-html="'高度同源區域:某些功能基因與「偽基因」序列極為相似，WGS 可能會發生「誤認」或難以對齊的情況。'/* ___ */"></li>
              <li v-html="'表觀遺傳學:標準 WGS 無法偵測 DNA 甲基化或組蛋白修飾。即便序列完全正常，如果開關(甲基化)出問題，基因仍可能不表現。'/* ___ */"></li>
              <li v-html="'嵌合體現象:如果變異僅存在於少數細胞中(例如只有 5%的細胞有突變)，標準濃度的 WGS 可能會將其視為背景雜訊而忽略。'/* ___ */"></li>
              <li v-html="'粒線體 DNA:雖然 WGS 包含粒線體，但由於粒線體與核 DNA 的比例差異巨大，有時需要專門的分析流程才能確保準確度。'/* ___ */"></li>
              <li v-html="'非編碼區的迷思:WGS 涵蓋了 98%的非編碼區，但目前人類對這些區域的功能瞭解極其有限，無法給出結論。'/* ___ */"></li>
              <li v-html="'染色體數目異常:針對染色體數目異常疾病(如:唐氏症、Turner syndrome、克藍費特氏症、Trisomy X 等)，WGS 僅能以讀序深度推估整體拷貝數變化而無法定論，故應以染色體檢查優先。'/* ___ */"></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="tpehealth-app-content-sub-container col-block width-full">
      <div class="tpehealth-app-content-sub-title-container row-block">
        <div class="tpehealth-app-content-sub-title">{{ '技術極限與聲明'/* ___ */ }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div class="tpehealth-app-content-sub-content-container col-block width-full">
        <ul>
          <li v-html="'由於現存實驗技術極限，部分基因之覆蓋深度可能未達 10X > 95%的標準。'/* ___ */"></li>
          <li v-html="'本檢測以美國人類遺傳學會 (ACMG) 及人類基因組變異資料庫 (ClinVar) 作為致病性判定依據，並參考人類孟德爾遺傳學資料庫 (OMIM) 所記載之基因相關表現型。然而，未曾被登載的位點，仍有可能導致疾病或影響表現型。'/* ___ */"></li>
          <li v-html="'本報告並非最終風險評估結果，仍需經合格醫師、遺傳諮詢師進行綜合臨床評估與建議。'/* ___ */"></li>
          <li v-html="'本檢測系統可能會隨時更新資料庫、演算法、檢測基因與位點，以及相關之檢測項目描述與內容，對於檢測系統及報告之更新，本院擁有最終解釋權。'/* ___ */"></li>
          <li v-html="'本檢測中藥物代謝相關基因之臨床解讀，係依據 PharmGKB(Pharmacogenomics Knowledgebase，藥物基因體資料庫) 與 ClinPGx(Clinical Pharmacogenomics，臨床藥物基因體學) 資料庫進行彙整 與判讀。PharmGKB 為美國國家衛生研究院(NIH)資助建立之權威藥物基因體學資料庫，系統性整合 基因變異與藥物反應、代謝途徑、不良反應及臨床用藥指引等相關證據，並依據證據強度對各基因位點 進行分級。為確保報告之科學性與可信度，本檢測僅選取 <b></li>Level 3 以上</b> 具充分文獻支持之基因位點進行 解讀。ClinPGx 則係將藥物基因體學應用於臨床醫療決策，透過分析個體基因變異對藥物療效、代謝能 力及不良反應風險之影響，協助臨床醫師進行更精準之用藥選擇與劑量調整。'/* ___ */"></li>
          <li v-html="'依據美國醫學遺傳學與基因體學對擴展性帶因者篩檢(Expanded Carrier Screening, ECS)之建議，帶 因者篩檢項目應採分層式(tier-based)設計，以兼顧臨床重要性與族群風險評估。ACMG 將建議篩檢 之疾病區分為三個階層:<b>Tier 1</b> 為所有族群皆應接受之基本篩檢項目，包括囊狀纖維化症(Cystic Fibrosis, CF)與脊髓性肌肉萎縮症(Spinal Muscular Atrophy, SMA)，並可依不同族群之高風險疾病 進行補充;<b>Tier 2</b> 為具嚴重或中度臨床表型，且於一般族群中帶因者頻率至少為 1/100 之遺傳疾病;<b>Tier 3</b> 則進一步涵蓋帶因者頻率達 ≥1/200 之遺傳疾病，以提供更全面之生育風險評估。本檢測項目之設計係 依循上述原則，作為評估受檢者潛在隱性遺傳疾病帶因風險之依據。'"></li>
        </ul>
      </div>
    </div>
    <div class="tpehealth-app-content-sub-container col-block width-full">
      <div class="tpehealth-app-content-sub-title-container row-block">
        <div class="tpehealth-app-content-sub-title">{{ '族裔分析檢測說明'/* ___ */ }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div class="tpehealth-app-content-sub-content-container col-block width-full">
        <ul>
          <li v-html="'此分析結合 1000 Genomes Project(1000G)與 Human Genome Diversity Project(HGDP)兩大公開 數據庫，透過數據整合與前處理，利用 PLINK 進行連鎖不平衡(Linkage Disequilibrium, LD)過濾，確 保基因型數據的獨立性，然後應用 ADMIXTURE 工具推算個體的祖源成分。此方法透過最大似然法 (Maximum Likelihood Estimation)評估不同族群的基因貢獻，並以可視化結果呈現祖源組成。'/* ___ */"></li>
          <li v-html="'使用者的數據將從 FASTQ 原始測序數據開始處理，首先進行比對(Mapping)，將讀取序列對齊到參考 基因組，接著執行**變異檢測(Variant Calling)**以識別 SNP 與 Indel 變異。隨後，從變異數據中篩選 與祖源分析相關的位點，確保與參考數據集中的標記位點一致，從而提高比較的準確性。'/* ___ */"></li>
          <li v-html="'然而，本方法的準確性受到參考數據庫的代表性影響，例如某些族群在 1000G 與 HGDP 數據中的涵蓋範 圍較少，可能導致結果偏差。此外，ADMIXTURE 的假設基於特定祖先群體模型，未必能完全反映歷史 上複雜的族群遷移與混合過程。LD 過濾雖可減少基因型連鎖影響，但可能影響某些族群特異性標記的保 留。此外，測序質量、變異檢測的準確度以及數據前處理的策略也會對分析結果產生影響。因此，在解 讀結果時，需考慮這些潛在限制，並輔以其他分析方法進行交叉驗證。'/* ___ */"></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    // static
    sampleInfoOptions () {
      return [
        {
          title: '樣本庫試劑組'/* ___ */,
          value: 'Whole Genome Sequencing PCR-Free',
          contentBold: true
        },
        {
          title: '數據量'/* ___ */,
          value: '= X GB',
          contentBold: true
        },
        {
          title: '定序平台'/* ___ */,
          value: 'Illumina Novaseq X plus'
        },
        {
          title: '覆蓋深度'/* ___ */,
          value: '10X > 95%'
        },
        {
          title: 'Variant Calling 軟體'/* ___ */,
          value: 'Parabrick (4.5.0-1)  '
        },
        {
          title: '數據品質'/* ___ */,
          value: 'Q30 ≥ 85%'
        }
      ]
    }
  }
}
</script>
